/**
 * Global Constants
 * `请使用大写+下划线命名`
 */

export * from './host'
export * from './API'
export * from './model'

// 授权TOKEN
export const AUTH_TOKEN = 'JWT_TOKEN'

// 文件上传
export const UPLOAD_SIGN = 'UPLOAD_SIGN' // 签名
export const UPLOAD_POLICY = 'UPLOAD_POLICY' // 策略
export const UPLOAD_EXPIRE = 'UPLOAD_EXPIRE' // 过期时间
/**
 * OSS accessKeyId
 */
export const OSS_ACCESS_KEY_ID = 'OSS_ACCESS_KEY_ID'
export const OSS_UPLOAD_HOST = 'OSS_UPLOAD_HOST' // 上传oss的host

/**
 * 不需要清除的localStorage
 * `开发者在此添加不需要清除的Key,此方法注意使用`
 */
export const EXCLUDE_STORAGE_KEY: string[] = []

/**
 * 用户信息
 */
export const USER_INFO = 'USER_INFO'

export const MENU_ACTIVE_KEY = 'MENU_ACTIVE_KEY'

/**
 * 分页列表默认每页数目
 */
export const PageSize = 10
